import { MarketName } from "@/constants/marketName"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    supplyPoint: graphql(`
        fragment isElectricitySupplyPoint_SupplyPoint on SupplyPointType {
            marketName
        }
    `),
}

export function isElectricitySupplyPoint(
    fragment: FragmentOf<typeof graphQLFragments.supplyPoint>
) {
    const supplyPoint = readFragment(graphQLFragments.supplyPoint, fragment)

    return supplyPoint?.marketName === MarketName.FRA_ELECTRICITY
}

isElectricitySupplyPoint.fragments = graphQLFragments
